import _ from "lodash";
import UserActionTypes from "modules/user/constants/action_types";
import ActionTypes from "../constants/action_types";
import {ClausePreview} from "common/types/clause_preview";
import {
  ClausePreviewsFetchRequest,
  ClausePreviewsFetchResult,
} from "../actions/clause_previews_fetch";

export type ClausePreviewEntry =
  | {status: "loading"}
  | {status: "failed"}
  | {status: "loaded"; preview: ClausePreview};

export type ClausePreviewsState = Record<string, ClausePreviewEntry>;

interface Action {
  type: string;
  payload?: unknown;
}

const initialState: ClausePreviewsState = {};

export default function clausePreviewsReducer(
  state: ClausePreviewsState = initialState,
  action: Action,
): ClausePreviewsState {
  switch (action.type) {
    case ActionTypes.CLAUSE_PREVIEWS_FETCH.REQUEST: {
      const {keys} = action.payload as ClausePreviewsFetchRequest;
      return {
        ...state,
        ...Object.fromEntries(keys.map(key => [key, {status: "loading"}])),
      };
    }
    case ActionTypes.CLAUSE_PREVIEWS_FETCH.SUCCESS: {
      const {entries} = action.payload as ClausePreviewsFetchResult;
      return {
        ...state,
        ...Object.fromEntries(
          entries.map(({key, preview}) => [key, {status: "loaded", preview}]),
        ),
      };
    }
    case ActionTypes.CLAUSE_PREVIEWS_FETCH.ERROR:
      // The error carries no keys; failed entries retry on the next hover
      return _.mapValues(state, entry =>
        entry.status === "loading" ? {status: "failed"} : entry,
      );
    case UserActionTypes.USER_LOGOUT.SUCCESS:
      return initialState;
    default:
      return state;
  }
}
